<!-- 平台管理 - 按服务对象和服务项目分销任务管理 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div
                class="admin-content"
                :style="{ minHeight: adminContentMinHeight + 'px' }"
            >
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 车主服务分销任务</span>
                    <span class="x-task-remark">按车主和服务项目分销任务</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form">
                        <el-form
                            ref="dbsTaskQueryForm"
                            :model="dbsTaskQueryForm"
                        >
                            <el-row :gutter="20">
                                <el-col :span="4" :offset="1">
                                    <el-form-item prop="taskId">
                                        <el-input
                                            v-model="dbsTaskQueryForm.taskId"
                                            clearable
                                            placeholder="任务ID"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item prop="taskQueryType">
                                        <el-select
                                            v-model="
                                                dbsTaskQueryForm.taskQueryType
                                            "
                                            clearable
                                            placeholder="查询维度"
                                            @change="onDbsTaskQueryTypeChange"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                label="待接受的任务"
                                                value="AVAILABLE_TASK"
                                            ></el-option>
                                            <el-option
                                                label="我发布的任务"
                                                value="MY_PRODUCED_TASK"
                                            ></el-option>
                                            <el-option
                                                label="我接受的任务"
                                                value="MY_CONSUMED_TASK"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item prop="taskStatus">
                                        <el-select
                                            v-model="
                                                dbsTaskQueryForm.taskStatus
                                            "
                                            clearable
                                            placeholder="任务状态"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                label="已发布"
                                                :value="0"
                                            ></el-option>
                                            <el-option
                                                label="已接受"
                                                :value="1"
                                            ></el-option>
                                            <!--
                                            <el-option label="已分派" :value="2"></el-option>
                                            -->
                                            <el-option
                                                label="已完成"
                                                :value="3"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item prop="serviceType">
                                        <el-select
                                            v-model="
                                                dbsTaskQueryForm.serviceType
                                            "
                                            clearable
                                            placeholder="服务类型"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                label="汽车服务"
                                                :value="1"
                                            ></el-option>
                                            <el-option
                                                label="市场营销"
                                                :value="2"
                                            ></el-option>
                                            <el-option
                                                label="车辆安全检测"
                                                :value="3"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item class="el-align-center">
                                        <el-button
                                            @click="resetDbsTaskQueryForm"
                                            icon="fas fa-undo"
                                            >重 置</el-button
                                        >&nbsp;&nbsp;&nbsp;&nbsp;
                                        <el-button
                                            type="primary"
                                            @click="queryDbsTaskList(1000)"
                                            icon="fas fa-search"
                                            >查 询</el-button
                                        >
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="el-search-toolbar">
                        <el-button
                            type="primary"
                            size="small"
                            icon="fas fa-plus-circle"
                            @click="openDbsTaskEditDialog('add')"
                            >发布任务</el-button
                        >
                    </div>
                    <div class="el-search-list">
                        <el-table
                            ref="dbsTaskTable"
                            v-loading="dbsTaskQueryLoading"
                            element-loading-text="拼命加载中..."
                            element-loading-custom-class="el-loading-mask-opacity"
                            :class="{ loading: dbsTaskQueryLoading }"
                            :data="dbsTaskList"
                            :default-sort="dbsTaskQuerySort"
                            @sort-change="onDbsTaskQuerySortChange"
                            style="width: 100%"
                            class="el-table-overflow-x-hidden"
                            empty-text="暂无数据"
                        >
                            <el-table-column
                                label="#"
                                type="index"
                                width="50"
                            ></el-table-column>
                            <el-table-column
                                label="任务ID"
                                prop="taskId"
                                width="100"
                                align="center"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.taskId }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="任务发布方"
                                prop="taskProduceOrgId"
                                width="220"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <div>
                                        {{ scope.row.taskProduceOrgName }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="任务接受方"
                                prop="taskConsumeOrgId"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <div>
                                        {{ scope.row.taskConsumeOrgName }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="服务对象"
                                prop="taskServiceTargetCount"
                                width="80"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        v-if="
                                            scope.row.taskStatus == 2 ||
                                            scope.row.taskStatus == 3
                                        "
                                        type="text"
                                        @click="
                                            openDbsTaskViewDialog(
                                                'summary',
                                                scope.row
                                            )
                                        "
                                        >{{
                                            scope.row.taskServiceTargetCount
                                        }}</el-button
                                    >
                                    <el-button
                                        v-else
                                        type="text"
                                        @click="
                                            openDbsTaskViewDialog(
                                                'service',
                                                scope.row
                                            )
                                        "
                                        >{{
                                            scope.row.taskServiceTargetCount
                                        }}</el-button
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="总金额"
                                prop="totalAmounts"
                                width="100"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="含税总金额"
                                prop="totalTaxedAmounts"
                                width="100"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="税点"
                                prop="taxThreshold"
                                width="100"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="任务状态"
                                prop="taskStatus"
                                width="100"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <el-tag
                                        size="small"
                                        effect="dark"
                                        :type="
                                            getDbsTaskStatusTagType(
                                                scope.row.taskStatus
                                            )
                                        "
                                        >{{ scope.row.taskStatusName }}</el-tag
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="创建时间"
                                prop="createTime"
                                width="100"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="操作"
                                width="120"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        v-if="isAvailableDbsTask(scope.row)"
                                        class="task-consume-link"
                                        type="text"
                                        @click="consumeDbsTask(scope.row)"
                                        >接受任务</el-button
                                    >
                                    <el-button
                                        v-else-if="
                                            isDistributableDbsTask(scope.row)
                                        "
                                        class="task-distribute-link"
                                        type="text"
                                        @click="
                                            openDbsTaskDistributeDialog(
                                                'distribute',
                                                scope.row
                                            )
                                        "
                                        >分派任务</el-button
                                    >
                                    <el-button
                                        v-else
                                        type="text"
                                        @click="
                                            openDbsTaskViewDialog(
                                                'view',
                                                scope.row
                                            )
                                        "
                                        >查看任务</el-button
                                    >
                                    <el-dropdown
                                        size="small"
                                        trigger="click"
                                        @command="
                                            handleDbsTaskCommand(
                                                arguments[0],
                                                scope.row
                                            )
                                        "
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="el-icon-arrow-down el-icon--right"
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="view"
                                                >查看任务</el-dropdown-item
                                            >
                                            <el-dropdown-item
                                                v-if="
                                                    isAvailableDbsTask(
                                                        scope.row
                                                    )
                                                "
                                                command="consume"
                                                >接受任务</el-dropdown-item
                                            >
                                            <el-dropdown-item
                                                v-if="
                                                    isDistributableDbsTask(
                                                        scope.row
                                                    )
                                                "
                                                command="distribute"
                                                >分派任务</el-dropdown-item
                                            >
                                            <el-dropdown-item
                                                v-if="
                                                    isDistributableDbsTask(
                                                        scope.row
                                                    )
                                                "
                                                command="unconsume"
                                                >取消接受</el-dropdown-item
                                            >
                                            <el-dropdown-item
                                                v-if="
                                                    isModifiableDbsTask(
                                                        scope.row
                                                    )
                                                "
                                                command="edit"
                                                >修改任务</el-dropdown-item
                                            >
                                            <el-dropdown-item
                                                v-if="
                                                    isModifiableDbsTask(
                                                        scope.row
                                                    )
                                                "
                                                command="delete"
                                                divided
                                                >删除任务</el-dropdown-item
                                            >
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="el-search-pager">
                        <el-pagination
                            background
                            v-show="showDbsTaskQueryPager"
                            @current-change="onDbsTaskQueryCurrentPageChange"
                            :current-page.sync="dbsTaskQueryForm.currentPage"
                            :page-size="dbsTaskQueryForm.pageSize"
                            layout="slot, prev, pager, next, total"
                            :total="dbsTaskQueryTotal"
                        >
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button
                                        :class="{
                                            active:
                                                dbsTaskQueryForm.pageSize == 10,
                                        }"
                                        @click="
                                            onDbsTaskQueryPageSizeChange(10)
                                        "
                                        >10</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                dbsTaskQueryForm.pageSize == 20,
                                        }"
                                        @click="
                                            onDbsTaskQueryPageSizeChange(20)
                                        "
                                        >20</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                dbsTaskQueryForm.pageSize == 50,
                                        }"
                                        @click="
                                            onDbsTaskQueryPageSizeChange(50)
                                        "
                                        >50</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                dbsTaskQueryForm.pageSize ==
                                                100,
                                        }"
                                        @click="
                                            onDbsTaskQueryPageSizeChange(100)
                                        "
                                        >100</el-button
                                    >
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>

                    <!-- 添加/修改Dialog -->
                    <el-drawer
                        size="80%"
                        :visible.sync="dbsTaskEditDialogVisible"
                        @closed="closeDbsTaskEditDialog"
                    >
                        <span slot="title" class="el-drawer-title">
                            {{ dbsTaskEditDialogTitle }}</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                ref="dbsTaskEditForm"
                                :model="dbsTaskEditForm"
                                :rules="dbsTaskEditRules"
                                label-width="120px"
                            >
                                <div class="el-form-item-group">
                                    <div class="el-form-item-group-title">
                                        <span class="el-title-bar">
                                            任务基础信息</span
                                        >
                                    </div>
                                    <div class="el-form-item-group-content">
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item
                                                    label="任务名称"
                                                    prop="taskName"
                                                >
                                                    <el-col :span="18">
                                                        <el-input
                                                            v-model="
                                                                dbsTaskEditForm.taskName
                                                            "
                                                            :maxlength="100"
                                                        ></el-input>
                                                    </el-col>
                                                    <el-col :span="6">
                                                        <p
                                                            class="el-form-item-tips"
                                                        ></p>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item
                                                    label="服务类型"
                                                    prop="serviceType"
                                                >
                                                    <el-col :span="18">
                                                        <el-select
                                                            v-model="
                                                                dbsTaskEditForm.serviceType
                                                            "
                                                            clearable
                                                            :disabled="
                                                                dbsTaskServiceTypeDisabled
                                                            "
                                                            class="el-full-width"
                                                        >
                                                            <el-option
                                                                label="汽车服务"
                                                                :value="1"
                                                            ></el-option>
                                                            <el-option
                                                                label="市场营销"
                                                                :value="2"
                                                            ></el-option>
                                                            <el-option
                                                                label="车辆安全检测"
                                                                :value="3"
                                                            ></el-option>
                                                        </el-select>
                                                    </el-col>
                                                    <el-col :span="6">
                                                        <p
                                                            class="el-form-item-tips"
                                                        ></p>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <!-- 如果是拥有全部组织的人则需要明确指定发布方组织ID，否则以当前操作人的组织ID作为发布方组织ID -->
                                            <el-col
                                                :span="12"
                                                v-if="
                                                    showDbsTaskProduceOrgSelect
                                                "
                                            >
                                                <el-form-item
                                                    label="任务发布方"
                                                    prop="taskProduceOrgId"
                                                    :rules="[
                                                        {
                                                            required: true,
                                                            message:
                                                                '请选择任务发布方!',
                                                        },
                                                    ]"
                                                >
                                                    <el-col :span="18">
                                                        <el-select
                                                            v-model="
                                                                dbsTaskEditForm.taskProduceOrgId
                                                            "
                                                            filterable
                                                            :filter-method="
                                                                filterAllOrgs
                                                            "
                                                            @visible-change="
                                                                resetOrgSelectFilterQuery
                                                            "
                                                            class="el-full-width"
                                                        >
                                                            <el-option
                                                                v-for="item in dbsTaskEditProduceOrgSelectOptions"
                                                                :key="
                                                                    item.orgId
                                                                "
                                                                :label="
                                                                    item.orgName
                                                                "
                                                                :value="
                                                                    item.orgId
                                                                "
                                                                class="org-select-option"
                                                            >
                                                                <span
                                                                    class="option-left"
                                                                    >{{
                                                                        item.orgCode
                                                                    }}</span
                                                                >
                                                                <span
                                                                    class="option-right"
                                                                    >{{
                                                                        item.orgName
                                                                    }}</span
                                                                >
                                                            </el-option>
                                                        </el-select>
                                                    </el-col>
                                                    <el-col :span="6">
                                                        <p
                                                            class="el-form-item-tips"
                                                        ></p>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item
                                                    label="任务接受方"
                                                    prop="taskConsumeOrgId"
                                                >
                                                    <el-col :span="18">
                                                        <el-select
                                                            v-model="
                                                                dbsTaskEditForm.taskConsumeOrgId
                                                            "
                                                            filterable
                                                            clearable
                                                            :filter-method="
                                                                filterAllOrgs
                                                            "
                                                            @visible-change="
                                                                resetOrgSelectFilterQuery
                                                            "
                                                            class="el-full-width"
                                                        >
                                                            <el-option
                                                                v-for="item in dbsTaskEditConsumeOrgSelectOptions"
                                                                :key="
                                                                    item.orgId
                                                                "
                                                                :label="
                                                                    item.orgName
                                                                "
                                                                :value="
                                                                    item.orgId
                                                                "
                                                                class="org-select-option"
                                                            >
                                                                <span
                                                                    class="option-left"
                                                                    >{{
                                                                        item.orgCode
                                                                    }}</span
                                                                >
                                                                <span
                                                                    class="option-right"
                                                                    >{{
                                                                        item.orgName
                                                                    }}</span
                                                                >
                                                            </el-option>
                                                        </el-select>
                                                    </el-col>
                                                    <el-col :span="6">
                                                        <p
                                                            class="el-form-item-tips"
                                                        ></p>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item
                                                    label="税点"
                                                    prop="taxThreshold"
                                                >
                                                    <el-col :span="18">
                                                        <el-input
                                                            v-model="
                                                                dbsTaskEditForm.taxThreshold
                                                            "
                                                            :maxlength="10"
                                                        ></el-input>
                                                    </el-col>
                                                    <el-col :span="6">
                                                        <p
                                                            class="el-form-item-tips"
                                                        >
                                                            百分点
                                                        </p>
                                                    </el-col>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item
                                                    label="总金额"
                                                    prop="totalAmounts"
                                                >
                                                    <el-col :span="6">
                                                        <el-input
                                                            v-model="
                                                                dbsTaskEditForm.totalAmounts
                                                            "
                                                            :maxlength="12"
                                                            readonly
                                                        ></el-input>
                                                    </el-col>
                                                    <el-col :span="4">
                                                        <p
                                                            class="el-form-item-tips el-padding-no"
                                                        >
                                                            (不含税)
                                                        </p>
                                                    </el-col>
                                                    <el-col :span="6">
                                                        <el-input
                                                            v-model="
                                                                dbsTaskEditForm.totalTaxedAmounts
                                                            "
                                                            :maxlength="12"
                                                            readonly
                                                        ></el-input>
                                                    </el-col>
                                                    <el-col :span="2">
                                                        <p
                                                            class="el-form-item-tips el-padding-no"
                                                        >
                                                            (含税)
                                                        </p>
                                                    </el-col>
                                                    <el-col :span="6"> </el-col>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>

                                <div class="el-form-item-group">
                                    <div class="el-form-item-group-title">
                                        <span class="el-title-bar">
                                            任务明细信息</span
                                        >
                                        <el-button
                                            type="primary"
                                            size="small"
                                            icon="fas fa-plus"
                                            @click="addDbsTaskServiceTarget()"
                                            style="float: right"
                                            >添加明细</el-button
                                        >
                                    </div>
                                    <div class="el-form-item-group-content">
                                        <el-row>
                                            <el-col :span="24">
                                                <el-table
                                                    :data="
                                                        dbsTaskEditForm.taskServiceTargets
                                                    "
                                                    style="width: 100%"
                                                    :max-height="
                                                        dbsTaskEditTableHeight
                                                    "
                                                    class="el-form-item-table"
                                                >
                                                    <el-table-column
                                                        label="#"
                                                        type="index"
                                                        width="40"
                                                    ></el-table-column>
                                                    <el-table-column
                                                        :label="
                                                            isScyxEdit
                                                                ? '服务对象'
                                                                : '车主姓名'
                                                        "
                                                        prop="targetName"
                                                        width="100"
                                                    >
                                                        <template
                                                            slot-scope="scope"
                                                        >
                                                            <span>{{
                                                                scope.row
                                                                    .targetName
                                                            }}</span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        :label="
                                                            isScyxEdit
                                                                ? '服务标的'
                                                                : '车牌号码'
                                                        "
                                                        prop="plateNumber"
                                                        width="100"
                                                    >
                                                        <template
                                                            slot-scope="scope"
                                                        >
                                                            <span>{{
                                                                scope.row
                                                                    .plateNumber
                                                            }}</span>
                                                        </template>
                                                    </el-table-column>
                                                    <template
                                                        v-if="!isScyxEdit"
                                                    >
                                                        <el-table-column
                                                            label="车辆品牌型号"
                                                            prop="vehicleModel"
                                                            width="200"
                                                        >
                                                            <template
                                                                slot-scope="scope"
                                                            >
                                                                <span>{{
                                                                    scope.row
                                                                        .vehicleModel
                                                                }}</span>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                            label="车架号"
                                                            prop="vehicleVin"
                                                            width="120"
                                                        >
                                                            <template
                                                                slot-scope="scope"
                                                            >
                                                                <span>{{
                                                                    scope.row
                                                                        .vehicleVin
                                                                }}</span>
                                                            </template>
                                                        </el-table-column>
                                                    </template>
                                                    <el-table-column
                                                        label="服务明细"
                                                        prop="taskServiceDetails"
                                                    >
                                                        <template
                                                            slot-scope="scope"
                                                        >
                                                            <el-tag
                                                                size="small"
                                                                class="task-service-detail-tag"
                                                                v-for="serviceDetail in scope
                                                                    .row
                                                                    .taskServiceDetails"
                                                                :key="
                                                                    serviceDetail.serviceId
                                                                "
                                                                type="primay"
                                                            >
                                                                {{
                                                                    serviceDetail.serviceName
                                                                }}({{
                                                                    serviceDetail.servicePrice
                                                                }}{{
                                                                    serviceDetail.priceUnit
                                                                }}) x
                                                                {{
                                                                    serviceDetail.serviceCount
                                                                }}
                                                            </el-tag>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        label="服务费小计"
                                                        prop="subTotalAmounts"
                                                        width="100"
                                                    >
                                                        <template
                                                            slot-scope="scope"
                                                        >
                                                            <span>{{
                                                                scope.row
                                                                    .subTotalAmounts
                                                            }}</span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        label="操作"
                                                        width="120"
                                                    >
                                                        <template
                                                            slot-scope="scope"
                                                        >
                                                            <el-button
                                                                class="is-square"
                                                                size="mini"
                                                                type="primary"
                                                                icon="fas fa-pen"
                                                                title="修改该行"
                                                                @click="
                                                                    modDbsTaskServiceTarget(
                                                                        scope.row
                                                                    )
                                                                "
                                                            ></el-button>
                                                            <el-button
                                                                class="is-square"
                                                                size="mini"
                                                                type="primary"
                                                                icon="fas fa-minus"
                                                                title="删除该行"
                                                                @click="
                                                                    delDbsTaskServiceTarget(
                                                                        scope
                                                                    )
                                                                "
                                                            ></el-button>
                                                            <el-button
                                                                class="is-square"
                                                                size="mini"
                                                                type="primary"
                                                                icon="fas fa-plus"
                                                                title="添加一行"
                                                                @click="
                                                                    addDbsTaskServiceTarget()
                                                                "
                                                            ></el-button>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>
                            </el-form>
                            <div
                                class="el-drawer-content-footer"
                                style="padding: 15px 0"
                            >
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeDbsTaskEditDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="saveDbsTask"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 添加/更新车主服务Dialog -->
                    <el-dialog
                        :visible.sync="dbsTaskServiceTargetEditDialogVisible"
                        class="el-dialog-center"
                        width="70%"
                        @close="closeDbsTaskServiceTargetEditDialog"
                    >
                        <span class="el-dialog__title" slot="title">
                            {{ dbsTaskServiceTargetEditDialogTitle }}</span
                        >
                        <div>
                            <el-form
                                ref="dbsTaskServiceTargetEditForm"
                                :model="dbsTaskServiceTargetEditForm"
                                :rules="
                                    !isScyxEdit
                                        ? dbsTaskServiceTargetEditRules
                                        : dbsTaskServiceTargetEditRules2
                                "
                                label-width="250px"
                            >
                                <template v-if="isScyxEdit">
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item
                                                label="服务标的"
                                                prop="plateNumber"
                                            >
                                                <el-col :span="16">
                                                    <el-autocomplete
                                                        v-model="
                                                            dbsTaskServiceTargetEditForm.plateNumber
                                                        "
                                                        clearable
                                                        :fetch-suggestions="
                                                            searchDbsTaskPlateNumber
                                                        "
                                                        @select="
                                                            onDbsTaskPlateNumberSelected
                                                        "
                                                        @input="
                                                            onDbsTaskPlateNumberInput
                                                        "
                                                        @clear="
                                                            onDbsTaskPlateNumberClear
                                                        "
                                                        class="el-full-width"
                                                    >
                                                        <template
                                                            slot-scope="{
                                                                item,
                                                            }"
                                                        >
                                                            <div
                                                                class="platenumber-select-option"
                                                            >
                                                                <span
                                                                    class="option-left"
                                                                    >{{
                                                                        item.plateNumber
                                                                    }}</span
                                                                >
                                                                <span
                                                                    class="option-right"
                                                                    >{{
                                                                        item.targetName
                                                                    }}</span
                                                                >
                                                            </div>
                                                        </template>
                                                    </el-autocomplete>
                                                </el-col>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item
                                                label="服务对象"
                                                prop="targetName"
                                            >
                                                <el-col :span="16">
                                                    <el-input
                                                        v-model="
                                                            dbsTaskServiceTargetEditForm.targetName
                                                        "
                                                        :maxlength="10"
                                                    ></el-input>
                                                </el-col>
                                                <el-col :span="8">
                                                    <p
                                                        class="el-form-item-tips"
                                                    >
                                                        2~50个汉字、字母、数字及下划线组成.
                                                    </p>
                                                </el-col>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </template>
                                <template v-else>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item
                                                label="车牌号码"
                                                prop="plateNumber"
                                            >
                                                <el-col :span="16">
                                                    <el-autocomplete
                                                        v-model="
                                                            dbsTaskServiceTargetEditForm.plateNumber
                                                        "
                                                        clearable
                                                        :fetch-suggestions="
                                                            searchDbsTaskPlateNumber
                                                        "
                                                        @select="
                                                            onDbsTaskPlateNumberSelected
                                                        "
                                                        @input="
                                                            onDbsTaskPlateNumberInput
                                                        "
                                                        @clear="
                                                            onDbsTaskPlateNumberClear
                                                        "
                                                        class="el-full-width"
                                                    >
                                                        <template
                                                            slot-scope="{
                                                                item,
                                                            }"
                                                        >
                                                            <div
                                                                class="platenumber-select-option"
                                                            >
                                                                <span
                                                                    class="option-left"
                                                                    >{{
                                                                        item.plateNumber
                                                                    }}</span
                                                                >
                                                                <span
                                                                    class="option-right"
                                                                    >{{
                                                                        item.targetName
                                                                    }}</span
                                                                >
                                                            </div>
                                                        </template>
                                                    </el-autocomplete>
                                                </el-col>
                                                <el-col :span="8">
                                                    <p
                                                        class="el-form-item-tips"
                                                    >
                                                        例如：京A88888
                                                    </p>
                                                </el-col>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item
                                                label="车主姓名"
                                                prop="targetName"
                                            >
                                                <el-col :span="16">
                                                    <el-input
                                                        v-model="
                                                            dbsTaskServiceTargetEditForm.targetName
                                                        "
                                                        :maxlength="10"
                                                    ></el-input>
                                                </el-col>
                                                <el-col :span="8">
                                                    <p
                                                        class="el-form-item-tips"
                                                    >
                                                        2~50个汉字、字母、数字及下划线组成.
                                                    </p>
                                                </el-col>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item
                                                label="车辆品牌型号"
                                                prop="vehicleModel"
                                            >
                                                <el-col :span="16">
                                                    <el-input
                                                        v-model="
                                                            dbsTaskServiceTargetEditForm.vehicleModel
                                                        "
                                                        :maxlength="50"
                                                    ></el-input>
                                                </el-col>
                                                <el-col :span="8">
                                                    <p
                                                        class="el-form-item-tips"
                                                    ></p>
                                                </el-col>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item
                                                label="车架号"
                                                prop="vehicleVin"
                                            >
                                                <el-col :span="16">
                                                    <el-input
                                                        v-model="
                                                            dbsTaskServiceTargetEditForm.vehicleVin
                                                        "
                                                        :maxlength="50"
                                                    ></el-input>
                                                </el-col>
                                                <el-col :span="8">
                                                    <p
                                                        class="el-form-item-tips"
                                                    ></p>
                                                </el-col>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </template>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="服务明细"
                                            prop="taskServiceDetails"
                                            v-for="(
                                                taskServiceDetail, index
                                            ) in dbsTaskServiceTargetEditForm.taskServiceDetails"
                                            :key="index"
                                            required
                                        >
                                            <el-col :span="7">
                                                <el-form-item
                                                    :prop="
                                                        'taskServiceDetails[' +
                                                        index +
                                                        '].serviceId'
                                                    "
                                                    :rules="[
                                                        {
                                                            required: true,
                                                            message:
                                                                '请选择服务项目',
                                                        },
                                                    ]"
                                                >
                                                    <el-select
                                                        v-model="
                                                            taskServiceDetail.serviceId
                                                        "
                                                        placeholder="服务项目"
                                                        @change="
                                                            (value) => {
                                                                applyDefaultServicePrice(
                                                                    value,
                                                                    index
                                                                );
                                                            }
                                                        "
                                                        class="el-full-width"
                                                    >
                                                        <el-option
                                                            v-for="service in dbsTaskServiceItems"
                                                            :key="
                                                                service.serviceId
                                                            "
                                                            :label="
                                                                service.serviceName
                                                            "
                                                            :value="
                                                                service.serviceId
                                                            "
                                                        ></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="4">
                                                <el-form-item
                                                    style="margin-left: 10px"
                                                    :prop="
                                                        'taskServiceDetails[' +
                                                        index +
                                                        '].servicePrice'
                                                    "
                                                    :rules="[
                                                        {
                                                            required: true,
                                                            message:
                                                                '请输入服务价格',
                                                        },
                                                        {
                                                            pattern:
                                                                /^([0-9])+(\.[0-9]+)?$/,
                                                            message:
                                                                '服务价格必须是非负数!',
                                                        },
                                                    ]"
                                                >
                                                    <el-input
                                                        v-model="
                                                            taskServiceDetail.servicePrice
                                                        "
                                                        placeholder="服务价格"
                                                        :maxlength="10"
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="3">
                                                <el-form-item
                                                    style="margin-right: 10px"
                                                >
                                                    &nbsp;&nbsp;<el-tag
                                                        type="primary"
                                                        v-if="
                                                            taskServiceDetail.priceUnit
                                                        "
                                                        >{{
                                                            taskServiceDetail.priceUnit
                                                        }}</el-tag
                                                    >
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="2">
                                                <el-form-item
                                                    :prop="
                                                        'taskServiceDetails[' +
                                                        index +
                                                        '].serviceCount'
                                                    "
                                                    :rules="[
                                                        {
                                                            required: true,
                                                            message:
                                                                '请输入服务次数',
                                                        },
                                                        {
                                                            pattern:
                                                                /^[1-9]{1}\d*$/,
                                                            message:
                                                                '服务次数必须是正整数!',
                                                        },
                                                    ]"
                                                >
                                                    <el-input
                                                        v-model="
                                                            taskServiceDetail.serviceCount
                                                        "
                                                        placeholder="服务次数"
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item
                                                    style="margin-left: 20px"
                                                >
                                                    <el-button
                                                        v-if="index == 0"
                                                        type="primary"
                                                        size="small"
                                                        round
                                                        icon="fas fa-plus"
                                                        title="添加一行"
                                                        @click="
                                                            addDbsTaskServiceDetail
                                                        "
                                                    ></el-button>
                                                    <el-button
                                                        v-else
                                                        type="primary"
                                                        size="small"
                                                        round
                                                        icon="fas fa-minus"
                                                        title="删除该行"
                                                        @click="
                                                            delDbsTaskServiceDetail(
                                                                index
                                                            )
                                                        "
                                                    ></el-button>
                                                </el-form-item>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="服务费小计"
                                            prop="subTotalAmounts"
                                        >
                                            <el-col :span="16">
                                                <el-input
                                                    v-model="
                                                        dbsTaskServiceTargetEditForm.subTotalAmounts
                                                    "
                                                    :maxlength="50"
                                                    readonly
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="8">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                        <div slot="footer">
                            <el-button
                                icon="fas fa-ban"
                                @click="closeDbsTaskServiceTargetEditDialog"
                                >取 消</el-button
                            >
                            <el-button
                                type="primary"
                                icon="far fa-save"
                                @click="saveDbsTaskServiceTarget"
                                >确 定</el-button
                            >
                        </div>
                    </el-dialog>

                    <!-- 分派Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="dbsTaskDistributeDialogVisible"
                        @closed="closeDbsTaskDistributeDialog"
                    >
                        <span slot="title" class="el-drawer-title">
                            分派任务</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                v-custom-validator-apply="
                                    dbsTaskDistributeRules
                                "
                                ref="dbsTaskDistributeForm"
                                :model="dbsTaskDistributeForm"
                                :rules="dbsTaskDistributeRules"
                                label-width="300px"
                                label-suffix="："
                            >
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="服务类型">
                                            <el-col :span="12">
                                                {{
                                                    dbsTaskDistributeForm
                                                        .taskObj.serviceTypeName
                                                }}
                                            </el-col>
                                            <el-col :span="12"> </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="任务发布方">
                                            <el-col :span="12">
                                                {{
                                                    dbsTaskDistributeForm
                                                        .taskObj
                                                        .taskProduceOrgName
                                                }}
                                            </el-col>
                                            <el-col :span="12"> </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="任务接受方">
                                            <el-col :span="12">
                                                {{
                                                    dbsTaskDistributeForm
                                                        .taskObj
                                                        .taskConsumeOrgName
                                                }}
                                            </el-col>
                                            <el-col :span="12"> </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="任务总金额">
                                            <el-col :span="12">
                                                {{
                                                    dbsTaskDistributeForm
                                                        .taskObj.totalAmounts
                                                }}
                                            </el-col>
                                            <el-col :span="12"> </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="服务对象数">
                                            <el-col :span="12">
                                                {{
                                                    dbsTaskDistributeForm
                                                        .taskObj
                                                        .taskServiceTargetCount
                                                }}
                                            </el-col>
                                            <el-col :span="12"> </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="分派团队长"
                                            prop="leaderStaffId"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        dbsTaskDistributeForm.leaderStaffId
                                                    "
                                                    placeholder="团队长(支持名称或身份证模糊搜索)"
                                                    clearable
                                                    filterable
                                                    remote
                                                    :remote-method="
                                                        loadLeaderStaffs
                                                    "
                                                    :loading="
                                                        leaderStaffQueryLoading
                                                    "
                                                    @clear="
                                                        clearLeaderStaffQuerySelectOptions
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in leaderStaffQuerySelectOptions"
                                                        :key="item.staffId"
                                                        :label="item.staffName"
                                                        :value="item.staffId"
                                                        class="leader-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.idcard
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.staffName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div
                                class="el-drawer-content-footer"
                                style="padding: 15px 0"
                            >
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeDbsTaskDistributeDialog"
                                    >关 闭</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="distributeDbsTask"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 查看Dialog -->
                    <el-drawer
                        :with-header="false"
                        size="80%"
                        :visible.sync="dbsTaskViewDialogVisible"
                        @closed="closeDbsTaskViewDialog"
                    >
                        <div class="el-drawer-content">
                            <el-tabs
                                class="el-drawer-content-body"
                                v-model="dbsTaskViewActiveTabName"
                            >
                                <el-tab-pane
                                    label="任务基本信息"
                                    name="dbsTaskViewBasicInfo"
                                >
                                    <el-form
                                        class="el-form-detail"
                                        inline
                                        label-position="right"
                                        label-width="120px"
                                        label-suffix="："
                                    >
                                        <el-form-item label="任务ID">{{
                                            dbsTaskViewForm.taskId
                                        }}</el-form-item>
                                        <el-form-item label="任务名称">{{
                                            dbsTaskViewForm.taskName
                                        }}</el-form-item>

                                        <el-form-item label="服务类型">{{
                                            dbsTaskViewForm.serviceTypeName
                                        }}</el-form-item>
                                        <el-form-item label="总金额">{{
                                            dbsTaskViewForm.totalAmounts
                                        }}</el-form-item>

                                        <el-form-item label="税点">{{
                                            dbsTaskViewForm.taxThreshold
                                        }}</el-form-item>
                                        <el-form-item label="含税总金额">{{
                                            dbsTaskViewForm.totalTaxedAmounts
                                        }}</el-form-item>

                                        <el-form-item label="任务发布方">{{
                                            dbsTaskViewForm.taskProduceOrgName
                                        }}</el-form-item>
                                        <el-form-item label="任务发布者">{{
                                            dbsTaskViewForm.taskProduceByName
                                        }}</el-form-item>

                                        <el-form-item label="任务接受方">{{
                                            dbsTaskViewForm.taskConsumeOrgName
                                        }}</el-form-item>
                                        <el-form-item label="任务接受者">{{
                                            dbsTaskViewForm.taskConsumeByName
                                        }}</el-form-item>

                                        <el-form-item
                                            label="任务状态"
                                            style="width: 100%"
                                        >
                                            <el-tag
                                                size="small"
                                                effect="dark"
                                                :type="
                                                    getDbsTaskStatusTagType(
                                                        dbsTaskViewForm.taskStatus
                                                    )
                                                "
                                                >{{
                                                    dbsTaskViewForm.taskStatusName
                                                }}</el-tag
                                            >
                                        </el-form-item>

                                        <el-form-item label="任务分派状态">
                                            <el-tag
                                                size="small"
                                                effect="dark"
                                                :type="
                                                    getDbsTaskDistributeStatusTagType(
                                                        dbsTaskViewForm.distributeStatus
                                                    )
                                                "
                                                >{{
                                                    dbsTaskViewForm.distributeStatusName
                                                }}</el-tag
                                            >
                                        </el-form-item>
                                        <el-form-item label="任务分派时间">{{
                                            dbsTaskViewForm.distributeTime
                                        }}</el-form-item>

                                        <el-form-item label="创建时间">{{
                                            dbsTaskViewForm.createTime
                                        }}</el-form-item>
                                        <el-form-item label="修改时间">{{
                                            dbsTaskViewForm.updateTime
                                        }}</el-form-item>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane
                                    label="任务服务明细"
                                    name="dbsTaskViewServiceDetail"
                                >
                                    <el-table
                                        :data="
                                            dbsTaskViewForm.taskServiceTargets
                                        "
                                        v-loading="taskServiceTargetsLoading"
                                        element-loading-text="拼命加载中..."
                                        element-loading-custom-class="el-loading-mask-opacity"
                                        :class="{
                                            loading: taskServiceTargetsLoading,
                                        }"
                                        style="width: 100%"
                                        :max-height="dbsTaskViewTableHeight"
                                        class="el-form-item-table"
                                    >
                                        <el-table-column
                                            label="#"
                                            type="index"
                                            width="40"
                                        ></el-table-column>
                                        <el-table-column
                                            :label="
                                                isScyxView
                                                    ? '服务对象'
                                                    : '车主姓名'
                                            "
                                            prop="targetName"
                                            width="100"
                                        >
                                            <template slot-scope="scope">
                                                <span>{{
                                                    scope.row.targetName
                                                }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            :label="
                                                isScyxView
                                                    ? '服务标的'
                                                    : '车牌号码'
                                            "
                                            prop="plateNumber"
                                            width="100"
                                        >
                                            <template slot-scope="scope">
                                                <span>{{
                                                    scope.row.plateNumber
                                                }}</span>
                                            </template>
                                        </el-table-column>
                                        <template v-if="!isScyxView">
                                            <el-table-column
                                                label="车辆品牌型号"
                                                prop="vehicleModel"
                                                width="200"
                                            >
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row.vehicleModel
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                label="车架号"
                                                prop="vehicleVin"
                                                width="120"
                                            >
                                                <template slot-scope="scope">
                                                    <span>{{
                                                        scope.row.vehicleVin
                                                    }}</span>
                                                </template>
                                            </el-table-column>
                                        </template>
                                        <el-table-column
                                            label="服务明细"
                                            prop="taskServiceDetails"
                                        >
                                            <template slot-scope="scope">
                                                <el-tag
                                                    size="small"
                                                    class="task-service-detail-tag"
                                                    v-for="serviceDetail in scope
                                                        .row.taskServiceDetails"
                                                    :key="
                                                        serviceDetail.serviceId
                                                    "
                                                    type="primay"
                                                >
                                                    {{
                                                        serviceDetail.serviceName
                                                    }}({{
                                                        serviceDetail.servicePrice
                                                    }}{{
                                                        serviceDetail.priceUnit
                                                    }}) x
                                                    {{
                                                        serviceDetail.serviceCount
                                                    }}
                                                </el-tag>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="服务费小计"
                                            prop="subTotalAmounts"
                                            width="100"
                                        >
                                            <template slot-scope="scope">
                                                <span>{{
                                                    scope.row.subTotalAmounts
                                                }}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-tab-pane>
                                <el-tab-pane
                                    v-if="
                                        dbsTaskViewForm.taskStatus == 2 ||
                                        dbsTaskViewForm.taskStatus == 3
                                    "
                                    label="任务分派清单"
                                    name="dbsTaskViewSummary"
                                >
                                    <visp-task-service
                                        :task-id="dbsTaskViewForm.taskId"
                                        :service-type="
                                            dbsTaskViewForm.serviceType
                                        "
                                        :is-producer="isProducer"
                                    ></visp-task-service>
                                </el-tab-pane>
                            </el-tabs>
                            <div
                                class="el-drawer-content-footer"
                                style="padding: 15px 0"
                            >
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeDbsTaskViewDialog"
                                    >关 闭</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort, deepClone, randomCode } from '@/utils.js';
import { WINDOW_HEIGHT } from '@/constants.js';
import { ALL_ORG_ID, TARGET_MAX_SERVICE_AMOUNT } from '@/visp.js';

const TAX_THRESHOLD_PATTERN = /^([0-9])+(\.[0-9]{1,2})?$/;

export default {
    name: 'DbsDistribTask',
    data() {
        return {
            submiting: false,
            allOrgList: [],
            allServiceList: [],
            orgSelectFilterQuery: '',
            leaderStaffQueryLoading: false,
            leaderStaffQuerySelectOptions: [],
            dbsTaskActiveTabName: 'allDbsTasks',
            //任务模块
            dbsTaskQueryLoading: false,
            dbsTaskQuering: false,
            dbsTaskQueryForm: {
                taskId: '',
                taskQueryType: '',
                serviceType: '',
                pageSize: 10,
                currentPage: 1,
            },
            dbsTaskList: [],
            dbsTaskQueryTotal: 0,
            dbsTaskQuerySort: {
                prop: 'createTime',
                order: 'descending',
            },

            dbsTaskCurrentActionType: '',
            dbsTaskEditDialogVisible: false,
            dbsTaskViewDialogVisible: false,
            dbsTaskEditForm: {
                taskId: '',
                taskName: '',
                serviceType: '',
                taxThreshold: '0',
                totalAmounts: '0',
                totalTaxedAmounts: '0',
                taskProduceOrgId: '',
                taskConsumeOrgId: '',
                taskConsumeId: '',
                taskServiceTargets: [],
            },
            dbsTaskEditRules: {
                serviceType: [
                    {
                        required: true,
                        message: '请选择服务类型!',
                    },
                ],
                taxThreshold: [
                    {
                        required: true,
                        message: '请输入税点!',
                    },
                    {
                        pattern: TAX_THRESHOLD_PATTERN,
                        message: '税点必须是非负数且小数部分至多2位!',
                    },
                ],
                totalAmounts: [
                    {
                        required: true,
                        message: '总金额不能为空!',
                    },
                ],
                totalTaxedAmounts: [
                    {
                        required: true,
                        message: '含税总金额不能为空!',
                    },
                ],
                taskServiceTargets: [
                    {
                        type: 'array',
                        required: true,
                        message: '请填写车主服务明细!',
                    },
                ],
            },
            dbsTaskViewForm: {
                taskId: '',
                taskName: '',
                serviceType: '',
                serviceTypeName: '',
                taxThreshold: '',
                totalAmounts: '',
                totalTaxedAmounts: '',
                taskProduceOrgId: '',
                taskProduceOrgName: '',
                taskProduceByName: '',
                taskConsumeOrgId: null,
                taskConsumeOrgName: '',
                taskConsumeByName: '',
                taskStatus: '',
                taskStatusName: '',
                distributeTime: '',
                distributeStatus: '',
                distributeStatusName: '',
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: '',
                taskServiceTargets: [],
            },
            dbsTaskDistributeDialogVisible: false,
            dbsTaskDistributeForm: {
                taskId: '',
                taskObj: {},
                leaderStaffId: '',
            },
            dbsTaskDistributeRules: {
                taskId: [
                    {
                        required: true,
                        message: '任务ID不能为空!',
                    },
                ],
                leaderStaffId: [
                    {
                        type: 'number',
                        required: true,
                        message: '请选择团队长!',
                    },
                ],
            },

            dbsTaskViewActiveTabName: 'dbsTaskViewBasicInfo',
            dbsTaskDetailCurrentActionType: '',
            taskServiceTargetsLoading: false,
            dbsTaskServiceTargetEditDialogVisible: false,
            dbsTaskServiceTargetEditForm: {
                uid: '',
                targetId: '',
                targetName: '',
                plateNumber: '',
                vehicleModel: '',
                vehicleVin: '',
                subTotalAmounts: '0',
                taskServiceDetails: [],
            },
            dbsTaskServiceTargetEditRules: {
                targetName: [
                    {
                        required: true,
                        message: '请输入车主姓名!',
                    },
                    {
                        pattern: /^[a-zA-Z\u00a1-\uffff0-9_]{2,50}$/,
                        message: '车主姓名不合法!',
                    },
                ],
                plateNumber: [
                    {
                        required: true,
                        message: '请输入车牌号码!',
                    },
                ],
                taskServiceDetails: [
                    {
                        type: 'array',
                        required: true,
                        message: '请输入服务明细!',
                    },
                ],
                subTotalAmounts: [
                    {
                        type: 'number',
                        message:
                            '服务费累计不能超过' +
                            TARGET_MAX_SERVICE_AMOUNT +
                            '!',
                        max: TARGET_MAX_SERVICE_AMOUNT,
                    },
                ],
            },
            dbsTaskServiceTargetEditRules2: {
                targetName: [
                    {
                        required: true,
                        message: '请输入服务对象姓名!',
                    },
                    {
                        pattern: /^[a-zA-Z\u00a1-\uffff0-9_]{2,50}$/,
                        message: '服务对象姓名不合法!',
                    },
                ],
                plateNumber: [
                    {
                        required: true,
                        message: '请输入服务标的!',
                    },
                ],
                taskServiceDetails: [
                    {
                        type: 'array',
                        required: true,
                        message: '请输入服务明细!',
                    },
                ],
                subTotalAmounts: [
                    {
                        type: 'number',
                        message:
                            '服务费累计不能超过' +
                            TARGET_MAX_SERVICE_AMOUNT +
                            '!',
                        max: TARGET_MAX_SERVICE_AMOUNT,
                    },
                ],
            },
        };
    },
    computed: {
        loginUser() {
            return this.$store.state.loginUserAllData.loginUser;
        },
        showDbsTaskQueryPager() {
            if (this.dbsTaskQuering || this.dbsTaskQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        dbsTaskEditDialogTitle() {
            if (this.dbsTaskCurrentActionType == 'add') {
                return '发布分销任务';
            } else if (this.dbsTaskCurrentActionType == 'edit') {
                return '修改分销任务';
            } else {
                return '';
            }
        },
        showDbsTaskProduceOrgSelect() {
            //如果当前用户是拥有全部组织的人?那么需要展示选择任务接受方的，否则默认使用当前操作人的所属组织作为任务接受方
            return this.loginUser.orgId == ALL_ORG_ID;
        },
        dbsTaskEditTableHeight() {
            return WINDOW_HEIGHT - 390;
        },
        dbsTaskViewTableHeight() {
            return WINDOW_HEIGHT - 120;
        },
        dbsTaskEditProduceOrgSelectOptions() {
            if (this.orgSelectFilterQuery) {
                return this.allOrgList.filter((org) => {
                    if (org.orgCode.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    if (org.orgName.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    return false;
                });
            } else {
                return this.allOrgList.filter((org) => true);
            }
        },
        dbsTaskEditConsumeOrgSelectOptions() {
            if (this.orgSelectFilterQuery) {
                return this.allOrgList.filter((org) => {
                    if (org.orgCode.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    if (org.orgName.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    return false;
                });
            } else {
                return this.allOrgList.filter((org) => true);
            }
        },
        dbsTaskServiceTargetEditDialogTitle() {
            if (this.dbsTaskDetailCurrentActionType == 'add') {
                return '添加任务明细';
            } else if (this.dbsTaskDetailCurrentActionType == 'edit') {
                return '修改任务明细';
            } else {
                return '';
            }
        },
        dbsTaskServiceItems() {
            return this.allServiceList.filter((service) => {
                return service.serviceType == this.dbsTaskEditForm.serviceType;
            });
        },
        dbsTaskServiceTypeDisabled() {
            if (this.dbsTaskEditForm.taskServiceTargets.length) {
                return true;
            } else {
                return false;
            }
        },
        isScyxEdit() {
            return this.dbsTaskEditForm.serviceType == 2;
        },
        isScyxView() {
            return this.dbsTaskViewForm.serviceType == 2;
        },
        isProducer() {
            return (
                this.dbsTaskViewForm.taskProduceOrgId == this.loginUser.orgId
            );
        },
    },
    created() {
        this.loadAllOrgList();
        this.loadAllServiceList();
    },
    mounted() {
        this.queryDbsTaskList(1000);
    },
    methods: {
        isModifiableDbsTask(row) {
            //当前登录者创建的任务 && 任务状态是已创建待接受状态
            return (
                row.taskStatus == 0 &&
                row.taskProduceBy == this.loginUser.userId
            );
        },
        isDistributableDbsTask(row) {
            //当前登录者接受的任务 && 任务状态是已接受待分派状态
            return (
                row.taskStatus == 1 &&
                row.taskConsumeBy == this.loginUser.userId
            );
        },
        isAvailableDbsTask(row) {
            if (row.taskStatus == 0) {
                let notAvailableOrgIds = [ALL_ORG_ID, row.taskProduceOrgId];
                //已创建待接受状态
                if (row.taskConsumeOrgId) {
                    //如果指定了任务接受方(组织)?
                    //那么只能本组织的人能看见
                    return this.loginUser.orgId == row.taskConsumeOrgId;
                }
                //拥有全部组织ALL_ORG_ID的人不能接受任务 && 本组织不能接受本组织的任务
                return !notAvailableOrgIds.includes(this.loginUser.orgId);
            }
            return false;
        },
        getDbsTaskStatusTagType(status) {
            if (status == '0') {
                return 'purple';
            } else if (status == '3') {
                return 'success';
            } else {
                return 'lblue';
            }
        },
        getDbsTaskDistributeStatusTagType(status) {
            if (status == '0') {
                return 'info';
            } else if (status == '1') {
                return 'success';
            }
        },
        filterAllOrgs(value) {
            this.orgSelectFilterQuery = value;
        },
        loadAllOrgList() {
            let url = PLATFORM_API.of('/api/platform/upms/org/all');
            this.$http
                .get(url)
                .then((response) => {
                    let result = response.data;
                    if (result.success) {
                        this.allOrgList = result.data;
                    }
                })
                .catch(defaultApiErrorHandler);
        },
        loadAllServiceList() {
            let url = PLATFORM_API.of('/api/platform/visp/serviceitem/all');
            this.$http
                .get(url)
                .then((response) => {
                    let result = response.data;
                    if (result.success) {
                        this.allServiceList = result.data;
                    }
                })
                .catch(defaultApiErrorHandler);
        },
        resetOrgSelectFilterQuery() {
            this.orgSelectFilterQuery = '';
        },
        loadLeaderStaffs(query) {
            if (query) {
                this.leaderStaffQueryLoading = true;
                let url = PLATFORM_API.of('/api/platform/visp/staff/leaders');
                this.$http
                    .get(url, {
                        params: { staffName: query, idcard: query },
                    })
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.leaderStaffQuerySelectOptions = result.data;
                        } else {
                            this.leaderStaffQuerySelectOptions = [];
                        }
                    })
                    .catch((error) => {
                        this.leaderStaffQuerySelectOptions = [];
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        this.leaderStaffQueryLoading = false;
                    });
            }
        },
        clearLeaderStaffQuerySelectOptions() {
            this.leaderStaffQuerySelectOptions = [];
        },
        //任务模块
        queryDbsTaskList(loading) {
            this.dbsTaskQueryForm.currentPage = 1;
            this.doQueryDbsTaskList(loading);
        },
        doQueryDbsTaskList(loading) {
            this.dbsTaskQuering = true;
            if (loading) {
                this.dbsTaskQueryLoading = true;
            }
            setTimeout(() => {
                let params = Object.assign(
                    {},
                    this.dbsTaskQueryForm,
                    mapSort(this.dbsTaskQuerySort)
                );
                this.$http
                    .get(PLATFORM_API.of('/api/platform/visp/dbstask/list'), {
                        params: params,
                    })
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.dbsTaskList = result.data;
                            this.dbsTaskQueryTotal = result.totalRowCount;
                        } else {
                            this.dbsTaskList = [];
                            this.dbsTaskQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch((error) => {
                        this.dbsTaskList = [];
                        this.dbsTaskQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.dbsTaskQueryLoading = false;
                        }
                        this.dbsTaskQuering = false;
                    });
            }, loading);
        },
        onDbsTaskQueryTypeChange(value) {
            this.resetDbsTaskQueryForm();
            this.dbsTaskQueryForm.taskQueryType = value;
        },
        resetDbsTaskQueryForm() {
            this.$refs.dbsTaskQueryForm.resetFields();
        },
        onDbsTaskQuerySortChange(parameter) {
            if (
                this.dbsTaskQuerySort.prop != parameter.prop ||
                this.dbsTaskQuerySort.order != parameter.order
            ) {
                this.dbsTaskQuerySort.prop = parameter.prop;
                this.dbsTaskQuerySort.order = parameter.order;
                this.queryDbsTaskList(1000);
            }
        },
        onDbsTaskQueryPageSizeChange(pageSize) {
            this.dbsTaskQueryForm.pageSize = pageSize;
            this.queryDbsTaskList(1000);
        },
        onDbsTaskQueryCurrentPageChange(currentPage) {
            this.dbsTaskQueryForm.currentPage = currentPage;
            this.doQueryDbsTaskList(1000);
        },

        loadDbsTaskServiceTargets(taskId, callback) {
            this.taskServiceTargetsLoading = true;
            let url = PLATFORM_API.of(
                '/api/platform/visp/dbstask/' + taskId + '/details'
            );
            this.$http
                .get(url)
                .then((response) => {
                    let result = response.data;
                    if (result.success) {
                        callback.call(this, result.data);
                    } else {
                        callback.call(this, []);
                        this.$message.error(result.message);
                    }
                })
                .catch((error) => {
                    callback.call(this, []);
                    defaultApiErrorHandler.call(this, error);
                })
                .then(() => {
                    this.taskServiceTargetsLoading = false;
                });
        },
        attachDbsTaskServiceTargets(row, form) {
            if (
                !Array.isArray(row.taskServiceTargets) ||
                row.taskServiceTargets.length == 0
            ) {
                this.loadDbsTaskServiceTargets(
                    row.taskId,
                    (taskServiceTargets) => {
                        for (
                            let i = 0, len = taskServiceTargets.length;
                            i < len;
                            i++
                        ) {
                            taskServiceTargets[i].uid = randomCode(10);
                        }
                        row.taskServiceTargets = taskServiceTargets;
                        form.taskServiceTargets = taskServiceTargets;
                    }
                );
            }
        },
        openDbsTaskEditDialog(cmd, row) {
            if (cmd == 'edit' && row.taskStatus != 0) {
                this.$message.error('该任务正在进行中,不允许修改!');
            } else {
                this.dbsTaskCurrentActionType = cmd;
                this.dbsTaskEditDialogVisible = true;
                if (cmd == 'edit') {
                    Vue.nextTick(() => {
                        Object.keys(this.dbsTaskEditForm).forEach((name) => {
                            let value = row[name];
                            this.dbsTaskEditForm[name] = value;
                        });
                    });
                    //被动加载服务明细
                    this.attachDbsTaskServiceTargets(row, this.dbsTaskEditForm);
                }
            }
        },
        closeDbsTaskEditDialog() {
            this.submiting = false;
            this.dbsTaskEditDialogVisible = false;
            this.$refs.dbsTaskEditForm.resetFields();
            //手动reset
            this.dbsTaskEditForm.taskId = '';
            this.dbsTaskEditForm.taskServiceTargets = [];
        },
        handleDbsTaskCommand(cmd, row) {
            if (cmd == 'edit') {
                this.openDbsTaskEditDialog(cmd, row);
            } else if (cmd == 'view') {
                this.openDbsTaskViewDialog(cmd, row);
            } else if (cmd == 'distribute') {
                this.openDbsTaskDistributeDialog(cmd, row);
            } else if (cmd == 'delete') {
                this.deleteDbsTask(row);
            } else if (cmd == 'consume') {
                this.consumeDbsTask(row);
            } else if (cmd == 'unconsume') {
                this.unconsumeDbsTask(row);
            }
        },
        openDbsTaskDistributeDialog(cmd, row) {
            this.dbsTaskCurrentActionType = cmd;
            this.dbsTaskDistributeDialogVisible = true;
            this.dbsTaskDistributeForm.taskId = row.taskId;
            this.dbsTaskDistributeForm.taskObj = row;
        },
        closeDbsTaskDistributeDialog() {
            this.dbsTaskDistributeDialogVisible = false;
            this.$refs.dbsTaskDistributeForm.resetFields();
            this.dbsTaskDistributeForm.taskId = '';
            this.dbsTaskDistributeForm.taskObj = {};
        },
        distributeDbsTask() {
            let url = PLATFORM_API.of(
                '/api/platform/visp/dbstask/distribute/' +
                    this.dbsTaskDistributeForm.taskId +
                    '/' +
                    this.dbsTaskDistributeForm.leaderStaffId
            );
            this.$refs.dbsTaskDistributeForm.validate((valid) => {
                if (valid && !this.submiting) {
                    this.$confirm('您确定要分派该任务吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(() => {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http
                                .post(url, {})
                                .then((response) => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeDbsTaskDistributeDialog();
                                        this.$message.success(result.message);
                                        this.queryDbsTaskList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1000);
                    });
                } else {
                    return false;
                }
            });
        },
        openDbsTaskViewDialog(cmd, row) {
            this.dbsTaskCurrentActionType = cmd;
            this.dbsTaskViewDialogVisible = true;
            if (cmd == 'service') {
                this.dbsTaskViewActiveTabName = 'dbsTaskViewServiceDetail';
            } else if (cmd == 'summary') {
                this.dbsTaskViewActiveTabName = 'dbsTaskViewSummary';
            } else {
                this.dbsTaskViewActiveTabName = 'dbsTaskViewBasicInfo';
            }
            Vue.nextTick(() => {
                Object.keys(this.dbsTaskViewForm).forEach((name) => {
                    this.dbsTaskViewForm[name] = row[name];
                });
                //被动加载服务明细
                this.attachDbsTaskServiceTargets(row, this.dbsTaskViewForm);
            });
        },
        closeDbsTaskViewDialog() {
            this.dbsTaskViewDialogVisible = false;
            Object.keys(this.dbsTaskViewForm).forEach((name) => {
                if (Array.isArray(this.dbsTaskViewForm[name])) {
                    this.dbsTaskViewForm[name] = [];
                } else {
                    this.dbsTaskViewForm[name] = '';
                }
            });
        },
        addDbsTaskServiceTarget() {
            if (this.dbsTaskEditForm.serviceType) {
                this.dbsTaskDetailCurrentActionType = 'add';
                this.dbsTaskServiceTargetEditDialogVisible = true;
                this.dbsTaskServiceTargetEditForm.uid = randomCode(10);
                this.addDbsTaskServiceDetail();
            } else {
                this.$message.error('请先选择服务类型!');
            }
        },
        modDbsTaskServiceTarget(row) {
            this.dbsTaskDetailCurrentActionType = 'edit';
            this.dbsTaskServiceTargetEditDialogVisible = true;
            Vue.nextTick(() => {
                Object.keys(this.dbsTaskServiceTargetEditForm).forEach(
                    (name) => {
                        let value = row[name];
                        this.dbsTaskServiceTargetEditForm[name] = value;
                    }
                );
            });
        },
        delDbsTaskServiceTarget(scope) {
            console.log(scope);
            let index = this.findIndexOfDbsTaskServiceTargetByPlateNumber(
                scope.row.plateNumber
            );
            this.dbsTaskEditForm.taskServiceTargets.splice(index, 1);
        },
        closeDbsTaskServiceTargetEditDialog() {
            this.dbsTaskServiceTargetEditDialogVisible = false;
            this.dbsTaskDetailCurrentActionType = '';
            try {
                this.$refs.dbsTaskServiceTargetEditForm.resetFields();
            } catch (e) {
                console.error(e);
            }
            this.dbsTaskServiceTargetEditForm.uid = '';
            this.dbsTaskServiceTargetEditForm.taskServiceDetails = [];
        },
        addDbsTaskServiceDetail() {
            this.dbsTaskServiceTargetEditForm.taskServiceDetails.push({
                serviceId: '',
                serviceName: '',
                servicePrice: '',
                priceUnit: '',
                serviceCount: 1,
            });
        },
        delDbsTaskServiceDetail(index) {
            this.dbsTaskServiceTargetEditForm.taskServiceDetails.splice(
                index,
                1
            );
        },
        applyDefaultServicePrice(value, index) {
            let selectedServiceItem = this.allServiceList.find(
                (element) => element.serviceId == value
            );
            if (selectedServiceItem) {
                let existsServiceDetails =
                    this.dbsTaskServiceTargetEditForm.taskServiceDetails.filter(
                        (element) => element.serviceId == value
                    ).length;
                //此处existsServiceDetails包含了自身，所以其值大于等于1
                if (existsServiceDetails > 1) {
                    //某个服务项目已经选过了?
                    this.$message.error(
                        '对不起，服务明细项[' +
                            selectedServiceItem.serviceName +
                            ']已经存在了!'
                    );
                    this.resetDbsTaskServiceDetail(
                        this.dbsTaskServiceTargetEditForm.taskServiceDetails[
                            index
                        ]
                    );
                } else {
                    let taskServiceDetail =
                        this.dbsTaskServiceTargetEditForm.taskServiceDetails[
                            index
                        ];
                    taskServiceDetail.serviceName =
                        selectedServiceItem.serviceName;
                    taskServiceDetail.servicePrice =
                        selectedServiceItem.servicePrice;
                    taskServiceDetail.priceUnit = selectedServiceItem.priceUnit;
                    taskServiceDetail.serviceCount = 1;
                }
            }
        },
        resetDbsTaskServiceDetail(taskServiceDetail) {
            taskServiceDetail.serviceId = '';
            taskServiceDetail.serviceName = '';
            taskServiceDetail.servicePrice = '';
            taskServiceDetail.serviceCount = 1;
            taskServiceDetail.priceUnit = '';
        },
        saveDbsTaskServiceTarget() {
            this.$refs.dbsTaskServiceTargetEditForm.validate((valid) => {
                if (valid) {
                    let closeDialog = true;
                    let clonedDbstaskServiceTargetEditForm =
                        this.cloneDbstaskServiceTargetEditForm();
                    console.log(clonedDbstaskServiceTargetEditForm);

                    if (this.dbsTaskDetailCurrentActionType == 'add') {
                        let plateNumber =
                            this.dbsTaskServiceTargetEditForm.plateNumber;
                        let index =
                            this.findIndexOfDbsTaskServiceTargetByPlateNumber(
                                plateNumber
                            );
                        if (index >= 0) {
                            this.$message.error(
                                '对不起，表格中已经存在' +
                                    plateNumber +
                                    '的服务明细，不能重复添加!'
                            );
                            closeDialog = false;
                        } else {
                            this.dbsTaskEditForm.taskServiceTargets.push(
                                clonedDbstaskServiceTargetEditForm
                            );
                        }
                    } else if (this.dbsTaskDetailCurrentActionType == 'edit') {
                        let uid = this.dbsTaskServiceTargetEditForm.uid;
                        let index =
                            this.findIndexOfDbsTaskServiceTargetByUid(uid);
                        if (index >= 0) {
                            //更新替换
                            this.dbsTaskEditForm.taskServiceTargets.splice(
                                index,
                                1,
                                clonedDbstaskServiceTargetEditForm
                            );
                        }
                    }
                    if (closeDialog) {
                        this.closeDbsTaskServiceTargetEditDialog();
                    }
                }
            });
        },
        cloneDbstaskServiceTargetEditForm() {
            return deepClone(this.dbsTaskServiceTargetEditForm);
        },
        findIndexOfDbsTaskServiceTargetByPlateNumber(plateNumber) {
            return this.dbsTaskEditForm.taskServiceTargets.findIndex(
                (element) => element.plateNumber == plateNumber
            );
        },
        findIndexOfDbsTaskServiceTargetByUid(uid) {
            return this.dbsTaskEditForm.taskServiceTargets.findIndex(
                (element) => element.uid == uid
            );
        },
        searchDbsTaskPlateNumber(query, callback) {
            if (query && query.length >= 7) {
                let url = PLATFORM_API.of(
                    '/api/platform/visp/servicetarget/search'
                );
                this.$http
                    .get(url, {
                        params: { plateNumber: query },
                    })
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            callback(result.data);
                        } else {
                            callback([]);
                        }
                    })
                    .catch((error) => {
                        defaultApiErrorHandler.call(this, error);
                        callback([]);
                    })
                    .then(() => {});
            } else {
                callback([]);
            }
        },
        onDbsTaskPlateNumberSelected(item) {
            //自动填充
            if (item) {
                this.dbsTaskServiceTargetEditForm.targetId = item.targetId;
                this.dbsTaskServiceTargetEditForm.targetName = item.targetName;
                this.dbsTaskServiceTargetEditForm.plateNumber =
                    item.plateNumber;
                this.dbsTaskServiceTargetEditForm.vehicleModel =
                    item.vehicleModel;
                this.dbsTaskServiceTargetEditForm.vehicleVin = item.vehicleVin;
            }
        },
        onDbsTaskPlateNumberInput(value) {
            this.dbsTaskServiceTargetEditForm.targetId = '';
            this.dbsTaskServiceTargetEditForm.targetName = '';
            this.dbsTaskServiceTargetEditForm.plateNumber = value;
            this.dbsTaskServiceTargetEditForm.vehicleModel = '';
            this.dbsTaskServiceTargetEditForm.vehicleVin = '';
        },
        onDbsTaskPlateNumberClear() {
            this.dbsTaskServiceTargetEditForm.targetId = '';
            this.dbsTaskServiceTargetEditForm.targetName = '';
            this.dbsTaskServiceTargetEditForm.plateNumber = '';
            this.dbsTaskServiceTargetEditForm.vehicleModel = '';
            this.dbsTaskServiceTargetEditForm.vehicleVin = '';
        },
        saveDbsTask() {
            let url = '';
            let method = 'post';
            if (this.dbsTaskEditForm.taskId) {
                url = PLATFORM_API.of('/api/platform/visp/dbstask/update');
                method = 'put';
            } else {
                url = PLATFORM_API.of('/api/platform/visp/dbstask/create');
                method = 'post';
            }
            if (url) {
                this.$refs.dbsTaskEditForm.validate((valid) => {
                    if (valid && !this.submiting) {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http[method](url, this.dbsTaskEditForm)
                                .then((response) => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeDbsTaskEditDialog();
                                        this.$message.success(result.message);
                                        this.queryDbsTaskList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    } else {
                        return false;
                    }
                });
            }
        },
        deleteDbsTask(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/dbstask/delete/' + row.taskId
            );
            if (row.taskStatus == 0) {
                this.$confirm('您确定要删除该任务?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$http
                        .delete(url)
                        .then((response) => {
                            let result = response.data;
                            if (result.success) {
                                this.$message.success(result.message);
                                this.queryDbsTaskList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler);
                });
            } else {
                this.$message.error('该任务正在进行中,不允许删除!');
            }
        },
        consumeDbsTask(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/dbstask/consume/' + row.taskId
            );
            if (row.taskStatus == 0) {
                this.$confirm('您确定要接受该任务?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$http
                        .put(url)
                        .then((response) => {
                            let result = response.data;
                            if (result.success) {
                                this.$message.success(result.message);
                                this.queryDbsTaskList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler);
                });
            } else {
                this.$message.error('该任务已经被接受过了!');
            }
        },
        unconsumeDbsTask(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/dbstask/unconsume/' + row.taskId
            );
            if (row.taskStatus == 1) {
                this.$confirm('您确定要取消接受该任务?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$http
                        .delete(url)
                        .then((response) => {
                            let result = response.data;
                            if (result.success) {
                                this.$message.success(result.message);
                                this.queryDbsTaskList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler);
                });
            } else {
                this.$message.error('仅已接受的任务可取消接受!');
            }
        },
        updateTotalAmounts() {
            let taxThreshold = this.dbsTaskEditForm.taxThreshold;
            if (TAX_THRESHOLD_PATTERN.test(taxThreshold)) {
                taxThreshold = parseFloat(taxThreshold);
            } else {
                taxThreshold = 0;
            }
            let totalAmounts = 0;
            this.dbsTaskEditForm.taskServiceTargets.forEach((serviceTarget) => {
                serviceTarget.taskServiceDetails.forEach((serviceDetail) => {
                    totalAmounts +=
                        serviceDetail.servicePrice * serviceDetail.serviceCount;
                });
            });
            if (totalAmounts == 0) {
                this.dbsTaskEditForm.totalAmounts = 0;
                this.dbsTaskEditForm.totalTaxedAmounts = 0;
            } else {
                this.dbsTaskEditForm.totalAmounts = totalAmounts.toFixed(2);
                //结果四舍五入保留2位小数
                this.dbsTaskEditForm.totalTaxedAmounts = (
                    totalAmounts *
                    ((taxThreshold + 100) / 100.0)
                ).toFixed(2);
            }
        },
        updateSubTotalAmounts() {
            let subTotalAmounts = 0;
            let taskServiceDetails =
                this.dbsTaskServiceTargetEditForm.taskServiceDetails;
            if (Array.isArray(taskServiceDetails)) {
                taskServiceDetails.forEach((serviceDetail) => {
                    subTotalAmounts +=
                        serviceDetail.servicePrice * serviceDetail.serviceCount;
                });
            }
            this.dbsTaskServiceTargetEditForm.subTotalAmounts = subTotalAmounts;
        },
    },
    watch: {
        'dbsTaskEditForm.taxThreshold': function (newVal, oldVal) {
            this.updateTotalAmounts(); //更新总金额
        },
        'dbsTaskEditForm.taskServiceTargets': function (newVal, oldVal) {
            this.updateTotalAmounts(); //更新总金额
        },
        'dbsTaskServiceTargetEditForm.taskServiceDetails': {
            handler: function (newVal, oldVal) {
                this.updateSubTotalAmounts(); //更新单个服务对象的服务金额小计
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>
<style lang="scss">
.x-task-remark {
    line-height: 60px !important;
    font-size: 14px;
    color: #729e08;
    float: right;
}
.org-select-option,
.leader-select-option,
.platenumber-select-option {
    .option-left {
        float: left;
        color: $--color-primary;
        font-size: 13px;
        padding-right: 50px;
    }
    .option-right {
        float: right;
    }
}
.task-service-detail-tag {
    margin-right: 5px;
}
.task-consume-link {
    color: $--color-green !important;
}
.task-distribute-link {
    color: $--color-green !important;
}
</style>